export default "__VITE_ASSET__DFoSB4gR__"